import { render } from "./Puzzles.vue?vue&type=template&id=18dd29b2&scoped=true"
import script from "./Puzzles.vue?vue&type=script&lang=js"
export * from "./Puzzles.vue?vue&type=script&lang=js"

import "./Puzzles.vue?vue&type=style&index=0&id=18dd29b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dd29b2"]])

export default __exports__